import {
  CARD,
  HORIZONTAL_AUDIO_PLAYER,
  IMAGE,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import {
  KICKER_HINT,
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const SocialMedia3: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Card': {
        const audio = item.audios?.[0];
        const picture = item.pictures?.[0];

        columns.items.push({
          id: 'LAYOUT_LIST',
          type: LAYOUT_LIST,
          values: { align: 'center' },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                clearStyles: 'lg',
                height: '500px',
                // CAT-122x / WCAG 1.4.10: 300px + column padding overflowed 320 CSS px
                width: { _: '100%', sm: '300px' },
                padding: '0px'
              },
              items: [
                {
                  id: picture ? `${picture.id}` : `${item.id}_picture`,
                  type: IMAGE,
                  values: {
                    imageGenerationPlacement: 'card_image',
                    url: picture?.mediaUrl,
                    alt: picture?.name,
                    editButtonOneTheImage: true,
                    role: 'region'
                  },
                  items: [
                    {
                      id: 'LAYOUT_LIST_RIGHT',
                      type: LAYOUT_LIST,
                      values: { align: 'bottom' },
                      items: [
                        {
                          type: HORIZONTAL_AUDIO_PLAYER,
                          id: `${item.id}_audios`,
                          values: {
                            blocking: true,
                            variant: 'card',
                            fullBleed: false,
                            padding: '16px',
                            parentId: item.id,
                            audioId: audio?.id,
                            mediaUrl: audio?.mediaUrl || '',
                            subtitlesUrl: audio?.subtitlesUrl || '',
                            name: audio?.name || '',
                            autoPlay: audio?.autoPlay,
                            backgroundColor: 'white'
                          },
                          items: []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        });
        break;
      }
      case 'Text':
      case 'Question':
        columns.items.push({
          id: 'LAYOUT_LIST_RIGHT',
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            padded: false,
            height: { _: 'auto', lg: '100%' }
          },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                ...optionalFieldValues(optional, 'subtitle', KICKER_HINT),
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                ...optionalFieldValues(optional, 'title'),
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                ...optionalFieldValues(optional, 'body'),
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });
  root.items.push(columns);
  return root;
};
